module.exports = __webpack_public_path__ + "img/edit-icon.cfcc6fad.svg";